import { Trans, useTranslation } from 'next-i18next/pages';
import { CountryCode } from '@pkgs/api';
import { Copy } from '@ev-tech/ui-core-components/Copy';

import { TRANSLATION_NAMESPACE } from '@/i18n/config';
import { useConsentLabels } from '@/hooks/useConsentLabels';
import { ExpandableLabel } from '@/components/property-expose/ExpandableLabel/ExpandableLabel';

import styles from '../ContactForm.module.css';

export const PrivacyStatement = ({ countryAlpha2 }: { countryAlpha2?: CountryCode }) => {
  const isFrenchListing = countryAlpha2 === CountryCode.FR;
  const { t } = useTranslation(TRANSLATION_NAMESPACE.property_expose);
  const { entityName, ImprintButtonComponent, PrivacyLinkComponent, ImprintModalComponent } = useConsentLabels();

  return (
    <ExpandableLabel className={styles.expandableConsent} maxLines={3} data-testid="expose-contact-form_privacy-statement_expandable-label">
      <Copy
        className={styles.consentCopy}
        size="s"
        text={
          <Trans
            i18nKey={
              isFrenchListing ? 'search.contact.form.label.consentInformation.france' : 'search.contact.form.label.consentInformation'
            }
            values={{ officeName: entityName }}
            t={t}
            components={[<ImprintButtonComponent key="imprint-button" />, <PrivacyLinkComponent key="privacy-link" />]}
          />
        }
      />
      <ImprintModalComponent />
    </ExpandableLabel>
  );
};
